import { z } from 'zod';
export const AuditLogEntrySchema = z.object({
    _id: z.string(),
    tenant_id: z.string(),
    user_id: z.string().optional(),
    action: z.string().min(1), // e.g. 'charger.created', 'session.stopped'
    resource_type: z.string().min(1),
    resource_id: z.string(),
    details: z.record(z.string(), z.unknown()),
    ip_address: z.string(),
    user_agent: z.string(),
    timestamp: z.coerce.date(),
});
//# sourceMappingURL=audit.js.map